import services from 'api/services';
import * as Constants from './constants';
import { logError } from 'util/errors';

const { TicketService } = services;

export const loadTicket = (ticketId) => async (dispatch) => {
  try {
    dispatch({ type: Constants.GET_LOAD_TICKET_REQUEST });
    const response = await TicketService.loadTicket(ticketId);
    dispatch({ type: Constants.GET_LOAD_TICKET_SUCCESS, response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.GET_LOAD_TICKET_FAILURE, error: ex.message });
  }
};

export const updateInput = (ticketId, body, isAdaptiveTest) => async (dispatch) => {
  try {
    if (isAdaptiveTest) dispatch({ type: Constants.SET_ADAPTIVE_TEST_INPUT_REQUEST });
    else dispatch({ type: Constants.SET_NON_ADAPTIVE_TEST_INPUT_REQUEST });
    const response = await TicketService.updateInput(ticketId, body);
    if (isAdaptiveTest) dispatch({ type: Constants.SET_ADAPTIVE_TEST_INPUT_SUCCESS, response });
    else dispatch({ type: Constants.SET_NON_ADAPTIVE_TEST_INPUT_SUCCESS, response });
  } catch (ex) {
    logError(ex);
    if (isAdaptiveTest) dispatch({ type: Constants.SET_ADAPTIVE_TEST_INPUT_FAILURE, error: ex.message });
    else dispatch({ type: Constants.SET_NON_ADAPTIVE_TEST_INPUT_FAILURE, error: ex.message });
  }
};

export const closeTicket = (ticketId, body) => async (dispatch) => {
  try {
    dispatch({ type: Constants.SET_CLOSE_TICKET_REQUEST });
    const ticket = await TicketService.closeTicket(ticketId, body);
    dispatch({ type: Constants.SET_CLOSE_TICKET_SUCCESS, ticket });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.SET_CLOSE_TICKET_FAILURE, error: ex.message });
  }
};

export const reportQuestion = (body) => async (dispatch) => {
  try {
    dispatch({ type: Constants.SET_REPORT_QUESTION_REQUEST });
    const reportedQuestion = await TicketService.reportQuestion(body);
    dispatch({ type: Constants.SET_REPORT_QUESTION_SUCCESS, reportedQuestion });
  } catch (ex) {
    logError(ex);
    dispatch({ type: Constants.SET_REPORT_QUESTION_FAILURE, error: ex.message });
  }
};

export const setCurrentQuestionObject = (currentQuestionObject) => async (dispatch) => {
  dispatch({ type: Constants.SET_CURRENT_QUESTION_OBJECT, currentQuestionObject });
};

export const setCurrentOptionId = (currentOptionId) => async (dispatch) => {
  dispatch({ type: Constants.SET_CURRENT_OPTION_ID, currentOptionId });
};
